import { type CommonNamespace } from '../en-US/common';

export const common = {
  call: 'Llamar ',
  cancel: 'CANCELAR',
  chat_ready: '¡El chat con el cliente está listo!',
  contact: 'Contacto',
  desktop_only_message: 'Esta aplicación solo se puede usar en computadoras de escritorio. Visite este sitio web en un dispositivo compatible o ajuste el tamaño de la ventana de su navegador.',
  email: 'Email',
  hours: 'Lunes a Viernes, <nobr>8 am - 7 pm ET</nobr>',
  loading: 'Loading...',
  log_in: 'Acceso',
  log_out: 'Finalizar la Sesión',
  logging_in: 'Iniciar sesión...',
  logging_out: 'Cerrar sesión...',
  setting_up_connection: 'Configurando cliente y conexión...',
  submit: 'ENTREGAR',
} as const satisfies CommonNamespace;
